// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f32529e2","821":"5ab3ad76"}[chunkId] + ".chunk.js";
};